import { useState } from "react";
import { api } from "@/api";
import { FileText, Download, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function ConceptDoc() {
  const [busy, setBusy] = useState(false);
  const dl = async () => {
    setBusy(true);
    try {
      const res = await api.get("/docs/concept", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = "DispatchMe-Concept.pdf";
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error("Genereren mislukt"); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" data-testid="concept-doc-card">
      <div className="flex items-center gap-2 text-sm font-bold text-slate-900"><FileText style={{ width: 16, height: 16 }} /> Conceptdocument (pitch)</div>
      <p className="mt-1 text-sm text-slate-500">Genereer een PDF met inleiding, alle modules (functies, werking &amp; voorbeelden) en het volledige securitymodel — om DispatchMe als concept te pitchen.</p>
      <button data-testid="download-concept-btn" onClick={dl} disabled={busy}
        className="mt-3 inline-flex items-center gap-2 rounded-xl bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-blue-500 disabled:opacity-60">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} Download PDF
      </button>
    </div>
  );
}
